import React, { FunctionComponent, ReactElement,MouseEvent } from 'react'
import cx from 'classnames'
import domToReact from 'html-react-parser/lib/dom-to-react'
import parse, { DomElement, HTMLReactParserOptions } from 'html-react-parser/index'
import { updateHistoryState } from 'front-end-core/core/history'
import { CURRENT_AWARENESS } from 'constants/controllers'
import { dismissPopover } from 'services/OverlayService'
import { styleStringToObject } from 'helpers/parseHtmlContent'
import HoverIconButtonContainer from 'redux/containers/components/accordion/HoverIconButtonContainer'
import { ContentHeaderLabelContainerProps } from 'redux/containers/components/accordion/ContentHeaderLabelContainer'
import { ContentHeaderProps } from './ContentHeader'

const ContentHeaderLabel: FunctionComponent<ContentHeaderLabelProps> = ({
  id,
  nodeId,
  depth,
  atBottom,
  expanded,
  prefix,
  title,
  isLogged,
  children,
  eventCategory,
  setAccordionUrlNode,
  controller,
  setSignUpModalIsOpen
}: ContentHeaderLabelProps) => {
  const handleOnClick = (e: MouseEvent<HTMLLabelElement>):void => {
    if (!isLogged) {
      dismissPopover(e.target)
      e.preventDefault()
      e.stopPropagation()
      setSignUpModalIsOpen(true)
    } else {
      const urlNode = nodeId
      if (controller !== CURRENT_AWARENESS) {
        setAccordionUrlNode(urlNode)
        history.pushState({}, null, urlNode)
        updateHistoryState({ viewName: controller })
      }
    }
  }

  return (
    <label
      onClick={handleOnClick}
      className={cx(
        `min-h3 w-100 ma0 f5 normal flex items-center',
        'lh-title hover-underline shadow-none`,
        `depth-${eventCategory !== 'CA' ? 1 : depth}`,
        { underline: expanded }
      )}
      htmlFor={id + '/' + atBottom}
      data-event-category='Accordion'
      data-event-action={expanded ? 'Collapse' : 'Expand'}
      data-event-label={`[Content ${prefix}] ${(title || '').replace(
        /(<([^>]+)>)/gi,
        ''
      )}`}
    >
      {children}
      <div className='flex items-center'>
        <Title {...{ title, depth: eventCategory === 'CA' ? 1 : depth, eventCategory }} />
        <HoverIconButtonContainer {...{ nodeId }} />
      </div>
    </label>
  )
}

const Title: FunctionComponent<TitleProps> = ({ title, depth }) => {
  const contentDepthStyle = (depth: number) => ({ marginLeft: `${depth > 1 ? depth + 2 : 2}.75rem` })
  const trimmedTitle = title.replace(/style *= *"[^"]*"/g, '') // have to do exclude " instead of any char to stop the regex being too greedy.
  const cleanedTrimmedTitle = parseHtmlContent(trimmedTitle)

  return (
    <span
      style={contentDepthStyle(depth)}
      className='b mv5 mr9'
    >
      {cleanedTrimmedTitle}
    </span>
  )
}

const options: HTMLReactParserOptions = {
  replace: (domNode: DomElement) => {
    const { attribs, name, children } = domNode
    const styleObj = attribs && styleStringToObject(attribs.style)

    switch (name) {
      case 'p':
        return (
          React.createElement('p', { style: { ...styleObj, marginTop: 0, marginBottom: 0 } }, domToReact(children))
        )
      default:
        return null
    }
  }
}

const parseHtmlContent = (dirtyHtml: string) => parse(dirtyHtml, options)

interface TitleProps {
  title: string;
  depth: number;
}

type ParentProps =  ContentHeaderLabelContainerProps & Partial<ContentHeaderProps>

interface ContentHeaderLabelProps extends ParentProps{
  children: ReactElement
}

export default ContentHeaderLabel
